import React, { useEffect, useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../UI/Media';
import { Grid } from '../../UI/Grid/grid';
import { Link } from '../../UI/Elements/Link';
import NoozApi from '../../../services/NoozApi';

export const InstaImage = ({ image }) => (
  <a
    title='Go to instagram post'
    rel='nofollow'
    target='_blank'
    href='https://www.instagram.com/nooz_optics/'
    className='flex flex-col overflow-hidden justify-between cursor-pointer relative'>
    <div className='scale-100	hover:scale-105 transform ease-in-out duration-700'>
      <Image {...image} />
    </div>
  </a>
);

export const InstaFeed = ({ label, link }) => {
  const [instaPhotos, setInstaPhotos] = useState(null);

  const instaHeader = (
    <div className='flex items-center justify-between w-full'>
      <Label
        {...label}
        size='3xl'
        weight='bold'
        color={{ classname: 'white' }}
      />
      <Link
        {...link}
        rel='nofollow'
        target='_blank'
        label={{
          ...link.label,
          decoration: 'underline',
          color: { classname: 'white' },
          icon: {
            iconKey: 'HiChevronRight',
            color: { classname: 'white' },
          },
        }}
      />
    </div>
  );

  useEffect(() => {
    const scrapingInstagramPosts = async () =>
      NoozApi.get('/web/instagram/posts')
        .then((response) => {
          if (response && response?.data?.data) {
            setInstaPhotos(
              response.data.data.filter(
                (i) =>
                  i.media_url &&
                  (i.media_type === 'IMAGE' ||
                    i.media_type === 'CAROUSEL_ALBUM')
              )
            );
          }
        })
        .catch((err) => {
          console.warn(
            `\nCould not fetch instagram posts. Error status ${err}`
          );
          return null;
        });

    scrapingInstagramPosts();
  }, []);

  return (
    <div className='w-full'>
      <Grid
        grid={{
          itemsWidth:
            'min-w-10/12 md:w-1/2 md:min-w-5/12 xl:w-1/3 xl:min-w-1/3',
          isSlider: 'block',
          isWhite: true,
          itemsGrow: true,
          header: instaHeader,
          gridItems: instaPhotos?.map((post) => ({
            path: 'Marketing.InstaImage',
            items: [
              { key: 'image', media: { file: { url: post?.media_url } } },
            ],
          })),
        }}
      />
    </div>
  );
};
